<ng-template #pagination>
  @if ((rowCount || filteredTableData?.length) > pageSize && !isPaginationDisabled) {
    <ngb-pagination
      [collectionSize]="rowCount || filteredTableData?.length"
      [(page)]="currentPage"
      [pageSize]="pageSize"
      (pageChange)="changePage()"
      aria-label="Pagination"
      [maxSize]="paginationMaxPages"
    ></ngb-pagination>
  }
</ng-template>
<ng-template #searchFilter>
  @if (searchFilterType) {
    <sb-search-filter
      [searchFilterType]="searchFilterType"
      [dateRangeList]="dateRangeList"
      [startDate]="startDate"
      [endDate]="endDate"
      (resetAll)="onClickReset()"
      [(inputValue)]="searchFilters.textFilter"
      (inputValueChange)="changeFilters(false)"
      (changeDateRange)="dateRangeChange($event)"
      [placeholder]="searchText"
      [isSingleArea]="isFilterSingleArea"
      [hideResetButton]="isFilterHideReset || hideReset"
      [showFilters]="showFilters"
      [ngClass]="{ 'hidden-xs hidden-sm': selectedValue }"
      [filterCount]="filterCount()"
      [pageSize]="isPaginationDisabled ? null : pageSize"
      (pageSizeChange)="changePageSize($event)"
      [label]="searchFilterLabel"
      [hidden]="hideSearchFilterOnSelected && selectedValue"
      >
      @for (th of filterableSelectorTableColumns; track th) {
        @if (!filterGroups || th.doTriggerReload) {
          <sb-search-filter-item
            [name]="th.allLabel && !th.isMultiOption ? '' : th.name"
            >
            @if (!th.isMultiOption) {
              <select
                [(ngModel)]="searchFilters[th.id]"
                class="form-control"
                (change)="changeFilters(th.doTriggerReload)"
                >
                @for (option of th.options; track option) {
                  <option
                    [ngValue]="option.id"
                    class="space-between"
                    [innerHTML]="(option.name | translate) + (showOptionCount(th, option) ? ' (' + option.count + ')' : '')"
                    [disabled]="option.count === 0 && !th.doTriggerReload"
                  ></option>
                }
              </select>
            }
            @if (th.isMultiOption) {
              <sb-multiselect-dropdown
                [settings]="th.dropdownSettings"
                [data]="th.options"
                [(model)]="searchFilters[th.id]"
                [allLabel]="th.allLabel"
                (modelChange)="changeFilters(th.doTriggerReload)"
                (onSelect)="changeFilters(th.doTriggerReload)"
                (onSelectAll)="changeFilters(th.doTriggerReload)"
                class="w-100"
              ></sb-multiselect-dropdown>
            }
            @if (th.tooltip) {
              <sb-icon
                name="info"
                [ngbTooltip]="th.tooltip | translate"
                placement="bottom"
                class="ml-3"
              ></sb-icon>
            }
          </sb-search-filter-item>
        }
      }
      @for (th of filterableDateRangeTableColumns; track th) {
        @if (!filterGroups || th.doTriggerReload) {
          <sb-search-filter-item
            [name]="th.allLabel && !th.isMultiOption ? '' : th.name"
            >
            <sb-date-range-picker
              [dateRangeList]="dateRangeList"
              (onChange)="onChangeDate($event, th)"
              [customOptions]="customDateOptions"
              [startDate]="th.startDate"
              [endDate]="th.endDate"
              >
            </sb-date-range-picker>
          </sb-search-filter-item>
        }
      }
      @for (th of filterableCheckBoxListTableColumns; track th) {
        @if (!filterGroups || th.doTriggerReload) {
          <sb-search-filter-item
            [name]="th.allLabel && !th.isMultiOption ? '' : th.name"
            >
            <div class="filter-options-checkbox-list">
              @for (option of th.options; track option) {
                <div>
                  <sb-check-box [label]="option.name" [model]="th.id[option.id]"></sb-check-box>
                </div>
              }
            </div>
            @if (th.tooltip) {
              <sb-icon
                name="info"
                [ngbTooltip]="th.tooltip | translate"
                placement="bottom"
                class="ml-3"
              ></sb-icon>
            }
          </sb-search-filter-item>
        }
      }
      @if (filterableCheckBoxTableColumns.length > 0) {
        <div class="filter-checkbox-field">
          @for (th of filterableCheckBoxTableColumns; track th) {
            @if (!filterGroups || th.doTriggerReload) {
              <sb-search-filter-item>
                @if (!th.allLabel) {
                  <sb-check-box
                    [(model)]="searchFilters[th.id]"
                    (modelChange)="changeFilters(th.doTriggerReload)"
                    [isChecked]="searchFilters[th.id]"
                    [label]="th.filterLabel || th.name"
                  ></sb-check-box>
                }
                @if (th.allLabel) {
                  <sb-on-off-switch
                    [(model)]="searchFilters[th.id]"
                    [isChecked]="searchFilters[th.id]"
                    (modelChange)="changeFilters(th.doTriggerReload)"
                    [trueLabel]="th.filterLabel || th.name"
                    [falseLabel]="th.allLabel"
                    >
                  </sb-on-off-switch>
                }
                @if (th.tooltip) {
                  <sb-icon
                    name="info"
                    [ngbTooltip]="th.tooltip | translate"
                    placement="bottom"
                    class="ml-3"
                  ></sb-icon>
                }
              </sb-search-filter-item>
            }
          }
        </div>
      }
      @if (filterGroups) {
        <div class="w-100">
          <div class="mb-5">
            <sb-button message="SB_Summary" iconName="chart" buttonClass="link" (onClick)="showChart()"></sb-button>
          </div>
          <div ngbAccordion #filterAccordion="ngbAccordion">
            @for (group of filterGroups; track group) {
              <div ngbAccordionItem [id]="group.id" #item="ngbAccordionItem">

                <div ngbAccordionHeader class="accordion-header" [ngClass]="{ 'closed': item.collapsed }">
                  <button ngbAccordionButton class="btn-link w-100 space-between" (click)="toggleFilterGroup(group.id)">
                    <div class="align-center">
                      @if (group.iconName) {
                        <sb-icon [name]="group.iconName" [isActivity]="true" class="mr-4"></sb-icon>
                      }
                      <h2 [innerHTML]="group.name | translate"></h2>
                      <sb-icon [name]="!item.collapsed ? 'chevronDown' : 'chevronRight'" overrideStyle="solid" class="ml-3"></sb-icon>
                      </div>
                    <div class="p-large text-muted">
                      @if (!item.collapsed) {
                        <span>{{ group.filteredCount }} / </span>
                      }
                      <span [innerHTML]="group.count"></span>
                    </div>
                  </button>
                </div>

                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      @for (filter of group.filterItems; track filter) {
                        <div class="search-filter-groups-item" [hidden]="filter.isHidden">
                          <div class="space-between mb-4">
                            <h3 [innerHTML]="filter.name | translate"></h3>
                          </div>
                          <div class="search-filter-groups-item__buttons">
                            @for (option of filter.options; track option) {
                              <sb-button
                                [message]="option.shortName || option.name | translate"
                                [note]="(filter.otherFilterRequirements ? option.filteredCount + ' / ' : '') + option.count"
                                [isSelectable]="true"
                                [isSelected]="option.isSelected"
                                (onClick)="onToggleFilterGroupItem(group.id, filter.id, option.id)"
                                [isDisabled]="option.isDisabled"
                              ></sb-button>
                            }
                          </div>
                        </div>
                      }
                    </ng-template>
                  </div>
                </div>
              </div>
            }
          </div>
      </div>
    }
  </sb-search-filter>
}
</ng-template>
@if (isProcessing || isParentProcessing) {
  <div class="processing-spinner">
    <sb-icon name="loading" class="p-15"></sb-icon>
  </div>
}
@if (!isParentProcessing) {
  <div [ngClass]="{ 'disabled-area': isProcessing }">
    @if (summaries) {
      <div
        class="table-summary p-3 pt-4 hidden-xs"
        [ngClass]="{ 'table-summary--long': summaries.length > 3 }"
        >
        @for (summary of summaries; track summary) {
          <sb-summary-button
            [summary]="summary"
            [isSelected]="searchFilters[rowStateColumnId] === summary.id"
            (onClick)="onClickSummary(summary.id)"
          ></sb-summary-button>
        }
      </div>
    }
    @if (!isFilterLeftColumn) {
      <ng-container [ngTemplateOutlet]="searchFilter"></ng-container>
    }
    @if (tables || filteredTableData) {
      <div class="master-detail mt-5">
        <ng-template #tableContainer>
          @if (!isLoadingData && searchFilterType) {
            <div class="table__count">
              <div>
                <div class="text-info" [innerHtml]="tableInfo | translate"></div>
                <ng-container *ngTemplateOutlet="pagination"></ng-container>
              </div>
              @if (filteredTableData) {
                <div class="align-center">
                  @if (filteredTableData.length > 0) {
                    <div
                      [innerHTML]="resultsMessage()"
                      [ngClass]="{ 'p-15': filterGroups }"
                    ></div>
                  }
                  @if (!hideReset) {
                    <sb-button
                      buttonClass="link"
                      customClasses="ml-2"
                      [isAutoSize]="true"
                      message="SB_Reset"
                      (onClick)="onClickReset()"
                      [isDisabled]="filterCount() === 0 && allFilterGroupsInactive()"
                    ></sb-button>
                  }
                </div>
              }
            </div>
          }
          @if (!isLoadingData && filteredTableData?.length > 0) {
            @if (tables.length === 1) {
              @if (currentPageData(tables[0].id); as tableData) {
                <ng-container
                  [ngTemplateOutlet]="tableContent"
            [ngTemplateOutletContext]="{
              table: tables[0],
              tableData: tableData
            }"
                  >
                </ng-container>
              }
            }
            @if (tables.length > 1) {
              <div ngbAccordion #tableAccordion="ngbAccordion">
                @for (table of tables; track table) {
                  @if (currentPageData(table.id); as tableData) {
                    <div
                      ngbAccordionItem
                      [id]="'table-' + (table.id || '1')"
                      class="table-single"
                      [hidden]="table.id === '-1'"
                      #item="ngbAccordionItem"
                    >
                      <div ngbAccordionHeader [ngClass]="{ opened: !item.collapsed, closed: item.collapsed }">
                        <button ngbAccordionButton class="btn-link w-100 space-between">
                          <div class="align-center">
                            @if (table.iconName || iconClass) {
                              <sb-icon
                                [hasColor]="true"
                                [name]="table.iconName || iconClass + table?.id"
                                [isActivity]="true"
                                class="mr-4"
                              ></sb-icon>
                            }
                            <h2 [innerHTML]="table.name"></h2>
                            <sb-icon
                              [name]="!item.collapsed ? 'chevronDown' : 'chevronRight'"
                              overrideStyle="solid"
                              class="ml-3"
                            ></sb-icon>
                          </div>
                          <div class="p text-muted" [innerHTML]="tableData.length"></div>
                        </button>
                      </div>

                      <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                          <ng-template>
                            <ng-container
                              [ngTemplateOutlet]="tableContent"
                              [ngTemplateOutletContext]="{
                                table: table,
                                tableData: tableData
                              }"
                            >
                            </ng-container>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
            }
          }
          @if (pageSize > 10 && !isLoadingData) {
            <ng-container *ngTemplateOutlet="pagination"></ng-container>
          }
          @if (tableData && !isLoadingData && filteredTableData?.length === 0) {
            <sb-alert
              alertClass="info"
              message="{{ emptyMessage || 'SB_No_Results_Found' | translate }}"
            ></sb-alert>
          }
          @if (isError) {
            <sb-alert
              alertClass="danger"
              message="{{ errorMessage || 'SB_Error_Loading_Data' | translate }}"
            ></sb-alert>
          }
          <sb-loading [hasLoaded]="!isLoadingData && (tableData !== undefined || isError)"></sb-loading>
        </ng-template>
        @if (!hideTable()) {
          <div
            class="col-sm-12"
      [ngClass]="{
        'hidden-sm': selectedValue,
        'table--full-width': !isDataOnRight && !selectedValue && !placeholderText
      }"
            [style.flex-basis]="tableWidth + 'px'"
            >
            <div class="table__inner" [ngClass]="{ 'table--filterable': isFilterLeftColumn }">
              @if (isFilterLeftColumn) {
                <ng-container [ngTemplateOutlet]="searchFilter"></ng-container>
              }
              @if (!isDataOnRight) {
                <ng-container *ngTemplateOutlet="tableContainer"></ng-container>
              }
            </div>
          </div>
        }
        @if (isDataOnRight) {
          <div class="master-detail__detail">
            <sb-detail
              placeholderText="SB_Please_Make_A_Selection"
              placeholderIcon="searchSettings"
              [selectedValue]="!allFilterGroupsInactive()"
              [isLoading]="isLoadingData"
              >
              @if (!isLoadingData) {
                <div class="flex-column w-100 pl-4 pr-4">
                  <ng-container *ngTemplateOutlet="tableContainer"></ng-container>
                </div>
              }
            </sb-detail>
          </div>
        }
        <div
          [hidden]="!selectedValue || placeholderText || defaultValue || noContent()"
          #contentRef
          [style.flex-basis]="contentWidth + 'px'"
          class="master-detail__detail"
          >
          <ng-content></ng-content>
        </div>
        @if (placeholderText || selectedValue) {
          <div class="master-detail__detail">
            @if (!isDataOnRight) {
              @if (!isLoadingValue) {
                <sb-detail
                  [placeholderText]="placeholderText"
                  [placeholderIcon]="placeholderIcon"
                  [backText]="canGoBack() ? backText : null"
                  [(selectedValue)]="selectedValue"
                  [isLocationChange]="isLocationChange"
                  [ngClass]="{ 'hidden-xs hidden-sm': !selectedValue }"
                  >
                  <!-- Using cardDetail might later want to be conditional to vary layout -->
                  <sb-card-detail
                    [menuItems]="menuItems"
                    [selectedValue]="selectedValue"
                    [showBack]="!backText && canGoBack()"
                    [showBackSm]="true"
                    [isRouted]="isRouted"
                    [backgroundUrl]="cardBackgroundUrl"
                    (onClickBack)="back()"
                    >
                  </sb-card-detail>
                </sb-detail>
              }
              @if (isLoadingValue) {
                <sb-loading></sb-loading>
              }
            }
          </div>
        }
      </div>
    }
  </div>
}
@if (hasSelectionAction()) {
  <sb-banner
    [message]="bannerMessage()"
    [messageClass]="bannerMessageClass"
    [buttonMessage]="bannerButtonMessage"
    [confirmationMessage]="bannerConfirmationMessage"
    [confirmButtonMessage]="bannerConfirmButtonMessage"
    [isSubmitted]="bannerButtonIsSubmitted"
    (clickBannerButton)="bannerButtonClick()"
    position="fixed"
    alignment="bottom"
  ></sb-banner>
}
<sb-confirm-dialog></sb-confirm-dialog>
<ng-template #chartModal let-modal>
  <div class="space-between mb-5">
    <h2 [innerHTML]="chart?.title | translate" class="bold"></h2>
    <sb-button
      buttonClass="link"
      (onClick)="modal.close()"
      iconName="close"
      iconClasses="p-large"
      [isAutoSize]="true"
    ></sb-button>
  </div>
  <sb-chart [chartOption]="chart.option"></sb-chart>
</ng-template>

<ng-template #tableContent let-table="table" let-tableData="tableData">
  <div class="table-responsive mt-4">
    @if (note || exportSettings) {
      <div class="space-between p-4">
        <div>
          @if (note) {
            <div [innerHTML]="note | translate" class="text-info"></div>
          }
        </div>
        @if (exportSettings && isExport) {
          <sb-button
            message="SB_Export"
            buttonClass="link"
            customClasses="mb-2"
            iconName="download"
            [dropdownItems]="exportButtons"
            dropdownPlacement="bottom-right"
            [isLoading]="isExporting"
            (onClick)="export($event)"
          ></sb-button>
        }
      </div>
    }
    <table
      class="table table-striped table-align-cells-middle table-restrict"
      [ngClass]="{ 'table-hover': isRowClickable }"
      >
      @if (tableColumns) {
        <thead>
          <tr>
            @for (th of visibleTableColumns(); track th) {
              <th>
                @if (th.cellType !== cellTypes.Popover) {
                  <div
                    class="align-center"
              [ngClass]="{
                'justify-end': th.cellType === cellTypes.Currency || th.cellType === cellTypes.Numeric,
                'justify-center': th.id === specialTypes.isSelected.id
              }"
                    >
                    @if (!th.isSortable && th.name) {
                      <div [innerHTML]="th.name | translate"></div>
                    }
                    @if (th.isSortable) {
                      <sb-column-header
                        [label]="th.name"
                        [fieldName]="th.id"
                        [(sortType)]="sortType"
                        (sortTypeChange)="resetFormattedData()"
                        [(sortReverse)]="sortReverse"
                        (sortReverseChange)="resetFormattedData()"
                      ></sb-column-header>
                    }
                    @if (th.id === specialTypes.isSelected.id && !th.name) {
                      <div>
                        <sb-check-box
                          [isChecked]="isAllSelected"
                          [isReversed]="true"
                          (click)="toggleSelectAll()"
                          [tooltip]="th.tooltip || (isAllSelected ? 'SB_UNSelect_All' : 'SB_Select_All')"
                          [isDisabled]="isColumnDisabled(th.id)"
                          [label]="selectedIds.length.toString()"
                        ></sb-check-box>
                      </div>
                    }
                  </div>
                }
              </th>
            }
          </tr>
        </thead>
      }
      <tbody>
        @for (row of tableData; track row) {
          <tr
            [class]="getRowStateClass(row)"
          [ngClass]="{
            'row-selected': selectedValue?.id && row.id === selectedValue.id
          }"
            [ngbTooltip]="rowTooltip"
            placement="bottom"
            >
            @for (col of visibleTableColumns(); track col) {
              <td
                class="{{ (col?.cellClass || '') + ' ' + (row[col.id]?.cellClass || '') }}"
                [ngClass]="getCellClass(col, row[col.id])"
                (click)="onTableClick(table.id, row[rowKey || 'id'], col.id)"
                >
                @if (!col.isSpecial) {
                  <div
                    class="flex flex-wrap"
              [ngClass]="{
                'flex-column': col.items && isReadable(row[col.items[0].id]),
                'justify-end': col.cellType === cellTypes.Currency || col.cellType === cellTypes.Numeric
              }"
                    >
                    @for (item of col.items || [col]; track item) {
                      <div>
                        <ng-template #popContent>
                          <b [innerHTML]="col.name | translate"></b>
                          @for (popoverItem of getPopoverContentArray(row, item); track popoverItem) {
                            <div>
                              <sb-icon [name]="popoverItem.iconName" [ngbTooltip]="popoverItem.iconTooltip | translate"></sb-icon>
                              <span [innerHTML]="popoverItem.label | translate"></span>
                              @if (popoverItem.iconTooltip | translate) {
                                <span> </span>
                              }
                            </div>
                          }
                        </ng-template>
                        @if (showContent(item)) {
                          <div
                            class="align-center"
                  [ngClass]="{
                    'pointer text-primary': item.cellType === cellTypes.Popover
                  }"
                            [ngbPopover]="item.cellType === cellTypes.Popover ? popContent : null"
                            popoverClass="table-popover"
                            >
                            @if (!col.items && isReadable(getLabel(col, row))) {
                              <span
                                [innerHTML]="getLabel(col, row)"
                                [ngClass]="{ 'semi-bold': item.semiBold }"
                              ></span>
                            }
                            @if (showItemLabel(col, row, item)) {
                              <span [innerHTML]="getLabel(item, row)" class="p-small"></span>
                            }
                            @if (row[item.id]?.iconName || (row[item.id] && item.iconName)) {
                              <sb-icon
                                [hidden]="row[item.id]?.value === false"
                                [name]="row[item.id]?.iconName || item.iconName"
                                [ngClass]="item.iconClass"
                                [class.mr-2]="row[item.id] || row[item.id]?.label"
                                [ngbTooltip]="getIconTooltip(col, row, item) | translate"
                                placement="bottom"
                                [overrideStyle]="row[item.id]?.iconName || item.iconName ? 'solid' : 'light'"
                              ></sb-icon>
                            }
                          </div>
                        }
                        @if (item.cellType === cellTypes.Badge) {
                          <sb-badge
                            [message]="getLabel(col, row)"
                            [badgeClass]="getClass(col, row)"
                            [iconName]="row[item.id]?.iconName"
                            [options]="col.options && col.isEditable ? col.options : null"
                            [selectedOptionId]="row[col.id].id || row[col.id]"
                            (selectedOptionIdChange)="requestUpdateValue(col, row, $event)"
                            [tooltipText]="getTooltip(col, row, item)"
                          ></sb-badge>
                        }
                      </div>
                    }
                  </div>
                }
                @if (col.isSpecial) {
                  <div class="justify-center">
                    <!-- These could be one sb-button with dynamic properties but might be less clear -->
                    @if (col.id === specialTypes.filter.id) {
                      <sb-button
                        iconName="filter"
                        buttonClass="link"
                        customClasses="btn-auto text-center"
                        [tooltipText]="col.name"
                        tooltipPlacement="bottom"
                        [isDisabled]="isClickDisabled"
                      ></sb-button>
                    }
                    @if (col.id === specialTypes.isFavourite.id) {
                      <sb-button
                        iconName="favourite"
                        buttonClass="link"
                        customClasses="btn-auto text-center"
                        [iconStyle]="row[col.id]?.value ? 'solid' : 'light'"
                        iconClasses="text-gold"
                        [tooltipText]="row[col.id]?.value ? 'Deselect' : 'SB_Select'"
                        tooltipPlacement="bottom"
                        [isDisabled]="isClickDisabled"
                      ></sb-button>
                    }
                    @if (col.id === specialTypes.viewDetail.id) {
                      <sb-button
                        [iconName]="col.iconName || 'pageExternal'"
                        buttonClass="link"
                        customClasses="btn-auto"
                        [iconStyle]="col.iconStyle || 'regular'"
                        [tooltipText]="col.tooltip || col.name"
                        tooltipPlacement="bottom"
                        (onClick)="onTableClick(table.id, row[rowKey || 'id'], col.id)"
                        [isVisibleFunction]="col.isVisibleFunction"
                        [isDisabled]="isClickDisabled"
                        [dropdownItems]="col.buttons"
                      ></sb-button>
                    }
                    @if (col.id === specialTypes.edit.id) {
                      <sb-button
                        [iconName]="col.iconName || 'edit'"
                        [iconStyle]="col.iconStyle || 'regular'"
                        buttonClass="link"
                        customClasses="btn-auto"
                        [tooltipText]="col.tooltip || col.name"
                        tooltipPlacement="bottom"
                        [dropdownItems]="col.buttons"
                        [isVisibleFunction]="col.isVisibleFunction"
                        [dataItem]="row[rowKey || 'id']"
                      ></sb-button>
                    }
                    @if (col.id === specialTypes.avatar.id) {
                      <sb-avatar
                        [fullName]="row.name"
                        [firstName]="row.firstName"
                        [lastName]="row.lastName"
                        [personId]="row.personId"
                        [photoUrl]="row.photoUrl"
                        [isLoading]="loadingRecordId === row[rowKey || 'id']"
                      ></sb-avatar>
                    }
                    @if (col.id === specialTypes.isSelected.id) {
                      <sb-check-box
                        [isChecked]="isRowSelected(row[rowKey || 'id'])"
                        (onClick)="onCheckBoxClicked(row[rowKey || 'id'])"
                        [isDisabled]="isClickDisabled || isColumnDisabled(col.id) || row.isDisabled"
                      ></sb-check-box>
                    }
                  </div>
                }
                @if (col.cellType === cellTypes.ValueIcon) {
                  <div>
                    @if (row[col.id]?.value; as colValue) {
                      <sb-icon
                        [name]="getMatchedIcon(col, colValue)?.iconName"
                        [ngbTooltip]="getMatchedIcon(col, colValue)?.iconTooltip | translate"
                      ></sb-icon>
                    }
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
      @if (showTotalRow()) {
        <tfoot>
          <tr>
            @for (col of visibleTableColumns(); track col) {
              <th
                class="{{ col?.cellClass || '' }}"
                [ngClass]="col?.cellClass || ''"
                >
                @if (
                  (col?.showTotal ||
                  ((col?.cellType === cellTypes.Currency || col.cellType === cellTypes.Numeric) && totalByDefault)) &&
                  !col?.items
                  ) {
                  <div
                    class="flex flex-wrap justify-end"
                    >
                    <span
                      [innerHTML]="getTotalLabel(col, tableData)"
                      class="{{ col?.cellClass || '' }}"
                      [ngClass]="{ 'semi-bold': col.semiBold }"
                      [ngbTooltip]="'SB_Total' | translate"
                      >
                    </span>
                  </div>
                }
              </th>
            }
          </tr>
        </tfoot>
      }
    </table>
  </div>
</ng-template>
